import React from "react";

const OCR = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold mb-8">OCR</h1>
      <p className="text-gray-400 max-w-2xl text-center">
        Extract text from images with high precision. Upload your image and let our AI-powered OCR do the work.
      </p>
      <button className="mt-8 px-6 py-3 bg-gradient-to-r from-green-400 to-blue-400 text-white font-bold rounded-lg shadow-lg">
        Upload Image
      </button>
    </div>
  );
};

export default OCR;